import { render } from "./NotificationTemplate.vue?vue&type=template&id=1ce6b443&ts=true"
import script from "./NotificationTemplate.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__